import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentPricingSkeleton } from './TypeComponentPricing'
import type { TypeNt_experienceSkeleton } from './TypeNt_experience'

export interface TypeSectionSetOfPricingFields {
  internalTitle: EntryFieldTypes.Symbol
  headline?: EntryFieldTypes.Symbol
  body?: EntryFieldTypes.RichText
  pricingCards?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeComponentPricingSkeleton>>
  bottomText?: EntryFieldTypes.Symbol
  bottomRichText?: EntryFieldTypes.RichText
  bottomCallout?: EntryFieldTypes.RichText
  highlightTerms?: EntryFieldTypes.Object
  nt_experiences?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeNt_experienceSkeleton>>
}

export type TypeSectionSetOfPricingSkeleton = EntrySkeletonType<TypeSectionSetOfPricingFields, 'sectionSetOfPricing'>
export type TypeSectionSetOfPricing<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeSectionSetOfPricingSkeleton,
  Modifiers,
  Locales
>

export function isTypeSectionSetOfPricing<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeSectionSetOfPricing<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'sectionSetOfPricing'
}
